import { Resolutions } from '../common/const';

const params = {
    trigger: `custom`,
    contentCloning: true,
    contentAsHTML: true,
    triggerOpen: {
        click: true,
        mouseenter: true,
        tap: true,
    },
    triggerClose: {
        // click: true,
        tap: true,
        mouseleave: true,
    },
    functionBefore: function(instance, helper) {
        const target = helper.origin;
        if (target.hasAttribute(`data-fav-add`) && target.classList.contains(`active`)) {
            if (target.getAttribute(`data-fav-add`) === `fav`) {
                instance.content(`Удалить из избранного`);
            } else if (target.getAttribute(`data-fav-add`) === `comp`) {
                instance.content(`Удалить из сравнения`);
            }
        }
    }
};

function setTooltip(el) {
    let tooltip = $(el).tooltipster({
        ...params,
        theme: `tooltipster-shadow`,
        side: el.getAttribute(`data-tooltip`) ? el.getAttribute(`data-tooltip`) : `top`,
        interactive: el.hasAttribute(`data-fav-add`) ? true : false
    });
    return tooltip;
}

/**
 * тултипы
 */

export const initTooltip = () => {
    if (!$(`[data-tooltip]`).length) return;
    $(`[data-tooltip]`).each((i, el) => {
        if (!(el.hasAttribute(`data-fav-add`) && Resolutions.IS_TAB())) setTooltip(el);
    });
};

window.initTooltip = (el) => setTooltip(el);
